import { XCircle, DollarSign, CheckCircle } from "lucide-react";

const RulesModal = ({
  t,
  styles,
  theme,
  language,
  isRTL,
  advancementLimits,
  setShowAdvancementRulesModal,
  setShowAdvancementModal,
  formatCurrency,
}) => {
  const bulletStyle = (isRTL) => ({
    marginBottom: "12px",
    paddingLeft: isRTL ? "0" : "24px",
    paddingRight: isRTL ? "24px" : "0",
    position: "relative",
  });

  const bulletDot = (isRTL) => ({
    position: "absolute",
    [isRTL ? "right" : "left"]: "0",
    color: "#3b82f6",
    fontWeight: "800",
  });

  return (
    <div style={styles.modalOverlay} onClick={() => setShowAdvancementRulesModal(false)}>
      <div
        style={{ ...styles.modalContent, maxWidth: "700px" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={styles.modalHeader}>
          <h3 style={styles.modalTitle}>
            <DollarSign size={32} />
            {language === "ar" ? "قواعد طلب السلفة" : "Advancement Request Rules"}
          </h3>
          <button style={styles.closeButton} onClick={() => setShowAdvancementRulesModal(false)}>
            <XCircle size={28} />
          </button>
        </div>

        {/* Limits Info Box */}
        <div
          style={{
            background:
              theme === "dark"
                ? "linear-gradient(145deg, rgba(59, 130, 246, 0.15) 0%, rgba(37, 99, 235, 0.1) 100%)"
                : "linear-gradient(145deg, rgba(59, 130, 246, 0.08) 0%, rgba(59, 130, 246, 0.05) 100%)",
            border: `2px solid ${theme === "dark" ? "rgba(59, 130, 246, 0.3)" : "rgba(59, 130, 246, 0.2)"}`,
            borderRadius: "16px",
            padding: "24px",
            marginBottom: "24px",
          }}
        >
          <h4
            style={{
              fontSize: "18px",
              fontWeight: "800",
              color: theme === "dark" ? "#fff" : "#1e293b",
              marginBottom: "16px",
            }}
          >
            {language === "ar" ? "الحدود والقيود" : "Limits & Restrictions"}
          </h4>

          <ul style={{ listStyle: "none", padding: 0, margin: 0, fontSize: "15px", color: theme === "dark" ? "rgba(255, 255, 255, 0.85)" : "rgba(30, 41, 59, 0.85)", lineHeight: 1.8 }}>
            <li style={bulletStyle(isRTL)}>
              <span style={bulletDot(isRTL)}>•</span>
              <strong>{language === "ar" ? "الحد الأقصى:" : "Maximum Amount:"}</strong>{" "}
              {formatCurrency(advancementLimits.maxAmount)}
            </li>
            <li style={bulletStyle(isRTL)}>
              <span style={bulletDot(isRTL)}>•</span>
              <strong>{language === "ar" ? "عدد الأقساط:" : "Installments:"}</strong>{" "}
              {advancementLimits.installments?.min} - {advancementLimits.installments?.max}{" "}
              {language === "ar" ? "شهر" : "months"}
            </li>
            <li style={bulletStyle(isRTL)}>
              <span style={bulletDot(isRTL)}>•</span>
              {language === "ar"
                ? "سيتم خصم الأقساط تلقائياً من راتبك الشهري"
                : "Installments will be automatically deducted from your monthly salary"}
            </li>
            <li style={bulletStyle(isRTL)}>
              <span style={bulletDot(isRTL)}>•</span>
              {language === "ar"
                ? "يجب سداد السلفة الحالية قبل طلب سلفة جديدة"
                : "Current advancement must be repaid before requesting a new one"}
            </li>
            <li style={{ ...bulletStyle(isRTL), marginBottom: 0 }}>
              <span style={bulletDot(isRTL)}>•</span>
              {language === "ar"
                ? "جميع الطلبات تخضع للموافقة الإدارية"
                : "All requests are subject to management approval"}
            </li>
          </ul>
        </div>

        {/* Actions */}
        <div style={styles.modalActions}>
          <button style={styles.secondaryButton} onClick={() => setShowAdvancementRulesModal(false)}>
            {t.cancel}
          </button>
          <button
            style={styles.primaryButton}
            onClick={() => {
              setShowAdvancementRulesModal(false);
              setShowAdvancementModal(true);
            }}
          >
            <CheckCircle size={20} />
            {language === "ar" ? "فهمت، متابعة الطلب" : "Understood, Continue Request"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RulesModal;